import Component from '../component';

export default class WaitingBarOverlay extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.bindEvents();
  }

  bindEvents() {
    this.handlePageFetch = this.handlePageFetch.bind(this);
    this.handlePageRender = this.handlePageRender.bind(this);

    $(document).on(
      'turbolinks:request-start.WaitingBarOverlay',
      this.handlePageFetch
    );
    $(document).on(
      'turbolinks:request-end.WaitingBarOverlay',
      this.handlePageRender
    );
  }

  unbindEvents() {
    this.clearTimeout();

    $(document).off(
      'turbolinks:request-start.WaitingBarOverlay',
      this.handlePageFetch
    );
    $(document).off(
      'turbolinks:request-end.WaitingBarOverlay',
      this.handlePageRender
    );
  }

  clearTimeout() {
    clearTimeout(this.overlayTimeout);
    this.overlayTimeout = null;
  }

  showOverlay() {
    this.$element.show();
    setTimeout(() => this.makeOverlayVisible(), 100);
  }

  makeOverlayVisible() {
    this.$element.addClass('waitingBarOverlay--visible');
  }

  handlePageFetch() {
    this.overlayTimeout = setTimeout(() => this.showOverlay(), 1000);
  }

  handlePageRender() {
    this.$element.hide();
    this.$element.removeClass('waitingBarOverlay--visible');
  }
}
